import { render, staticRenderFns } from "./SuccessDialog.vue?vue&type=template&id=6cf45d68&scoped=true&"
import script from "./SuccessDialog.vue?vue&type=script&lang=js&"
export * from "./SuccessDialog.vue?vue&type=script&lang=js&"
import style0 from "./SuccessDialog.vue?vue&type=style&index=0&id=6cf45d68&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cf45d68",
  null
  
)

export default component.exports